import { Component, Input, ViewEncapsulation } from '@angular/core';

// For displaying register using compact-register-view-two-column component in left column and detail page in right column allowing user to select item from list in register and view details in right column. selected-id service used to pass selected id from left to right column and notify register of added or deleted items.
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-two-column-list-layout',
    styleUrls: ['./two-column-list-layout.component.scss'],
    templateUrl: './two-column-list-layout.component.html',
    standalone: false
})
export class TwoColumnListContentLayoutComponent {
   @Input() twoColumns = true;
}
